module.exports = __webpack_public_path__ + "img/expense-history.aea1c825.svg";